/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { VButtonComponent } from "./button/button.component";
import { VConfigDirective } from "./wrapper.directive";
import { VInputTextComponent } from "./input-text/input-text.component";
import { VInputNumberComponent } from "./input-number/input-number.component";
import { VDropdownComponent } from "./dropdown/dropdown.component";
import { VRadioButtonComponent } from "./radioButton/radioButton.component";
import { VContainerComponent } from "./wrapper.interface";
import { VPasswordComponent } from "./password/password.component";
import { VToggleButtonComponent } from "./toggleButton/toggleButton.component";
import { VCheckboxComponent } from "./checkbox/checkbox.component";
import { VInputTextareaComponent } from "./input-textarea/input-textarea.component";
import { VSliderComponent } from "./slider/slider.component";
import { VSelectButtonComponent } from "./selectButton/selectButton.component";
import { VInputSwitchComponent } from "./inputSwitch/inputSwitch.component";
import { VAutoCompleteComponent } from "./autoComplete/autoComplete.component";
import { VColorPickerComponent } from "./colorPicker/colorPicker.component";
import { VDatePickerComponent } from "./datePicker/datePicker.component";
import { VChipComponent } from "./chip/chip.component";
import { VTableSelectComponent } from "./tableSelect/tableSelect.component";
import { VMultiSelectComponent } from "./multiSelect/multiSelect.component";
import { VTagComponent } from "./tag/tag.component";
import { VFileUploadComponent } from "./fileUpload/fileUpload.component";
import { VFileUploadListComponent } from "./fileUpload-list/fileUpload-list.component";
import { VFileUploadPickerComponent } from "./fileUpload-picker/fileUpload-picker.component";
import { VHorizontalContainerComponent } from "./horizontal-container/horizontal-container.component";
import { VTimePickerComponent } from "./timePicker/timePicker.component";
import { VSplitbuttonComponent } from "./splitbutton/splitbutton.component";
import { VInputCurrencyComponent } from "./input-currency/input-currency.component";


/**
 * Add new modules here, they are automatically exported
 */
const components = [
    VCheckboxComponent,
    VInputTextComponent,
    VInputTextareaComponent,
    VInputNumberComponent,
    VInputCurrencyComponent,
    VSliderComponent,
    VDropdownComponent,
    VPasswordComponent,
    VRadioButtonComponent,
    VButtonComponent,
    VSplitbuttonComponent,
    VSelectButtonComponent,
    VToggleButtonComponent,
    VInputSwitchComponent,
    VAutoCompleteComponent,
    VColorPickerComponent,
    VDatePickerComponent,
    VTimePickerComponent,
    VChipComponent,
    VTableSelectComponent,
    VMultiSelectComponent,
    VTagComponent,
    VFileUploadComponent,
    VFileUploadPickerComponent,
    VFileUploadListComponent,
    VHorizontalContainerComponent,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode'}),
        ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode'}),
        ...components,
    ],
    exports: [
        ...components,
        VContainerComponent,
    ],
    declarations: [
        VContainerComponent,
        VConfigDirective,
    ],
})
export class VComponentsModule{}